module.exports = __webpack_public_path__ + "img/generated-mine.212b8e01.png";